if (!customElements.get('tech-bms-carousel')) {
  customElements.define('tech-bms-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-bms-viewport]');
      this.progress = this.querySelector('[data-bms-progress]');
      if (!this.viewport || !this.progress) return;

      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateProgress();
        });
      };
      this.onResize = () => this.updateProgress();
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.breakpoint.addEventListener('change', this.onResize);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.progress.parentElement);
      this.updateProgress();
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.breakpoint?.removeEventListener('change', this.onResize);
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    updateProgress() {
      const mobile = this.breakpoint.matches;
      this.viewport.tabIndex = mobile ? 0 : -1;
      if (!mobile) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const progress = maxScroll > 0
        ? Math.max(0, Math.min(1, this.viewport.scrollLeft / maxScroll))
        : 0;
      const trackWidth = this.progress.parentElement.clientWidth;
      const thumbWidth = this.progress.getBoundingClientRect().width;
      this.progress.style.transform = `translateX(${progress * Math.max(0, trackWidth - thumbWidth)}px)`;
    }
  });
}
